var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStadium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1085 961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#207243}.st4{fill:#fff}.st6{fill:#29485f;stroke:#e1dcd0;stroke-width:2;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a87b50",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    d: "M6 321S305 13 542 11c247-3 536 311 536 311l-83 98-63 148 16 95-294 294H437L142 662l17-95-65-147-88-99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 322S318 28 542 27c225 0 500 272 509 295l-69 86-68 156 16 91-284 285H446L160 655l14-94-65-147-77-92z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a87b50",
    d: "m605 786 1 13a64 64 0 1 1-126-13L216 523s110-163 326-163 326 163 326 163L605 786z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677 656-93 94a63 63 0 0 0-84 0l-92-94a64 64 0 0 0 1-83l92-91a63 63 0 0 0 83 0l92 91a63 63 0 0 0 1 83z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526 440 17-16 16 16-16 16zM343 625l16-16 17 16-17 16zM709 624l16-17 17 17-17 16z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m21 301 521 521 521-521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 798v14l-9 8h-7l-7-6v-16z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 137s1-25 19-26c19-1 28 13 47 1 0 0-4 16-16 20s-17 3-27 0c-9-2-14-5-23 5zM493 210h-9l-3 2-1 3v2s-5-2-7-6c-2-3-2-11-2-11s0-9 3-14c4-5 20-4 20-4v-25c1-3 4-5 4-5l5-3 20-8-3 11-1 3v75s-1 8-5 12l-10 8-18 12c0-1 6-6 7-10l1-11-1-31z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611 256-6-1c-3-1-6-11-6-11l-3-10-4-16c-3-12-7-16-10-21-3-4-9-7-9-7l8-7c6-6 10-12 12-16l4-16v-19c-2-8-7-14-9-17s-10-7-10-7l-32 20-11 8-4 6-2 9v80l-2 7-3 4 9-3 14-8 4-4 2-8v-17l1-1h2l3 1 3 4 1 4 5 20 3 17 1 4-3 3-5-2-17-5c-7-2-11-2-23 1-13 2-22 11-27 16s-12 16-12 17c0-1 3-3 12-7 9-5 17-4 25-5 8 0 18 5 18 5a504 504 0 0 0 16 5 408 408 0 0 1 12-16l5-7 1 2s2 2 2 5 5 10 12 14c7 5 12 3 12 3l12-20 3-6-4 2zm-41-73c-4 4-6 8-11 10l-4 1v-57l1-4 4-4 5-4 4 3 4 6 3 9 1 8-1 14c-1 3-3 14-6 18z",
    className: "st6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadium);
export default __webpack_public_path__ + "static/media/stadium.aee64e076987edb9107717509997ca06.svg";
export { ForwardRef as ReactComponent };